<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M37.2 2H10.8C8.2 2 6 4 6 6.5v34.9C6 44 8.2 46 10.8 46h20.4c1.5 0 2.9-.6 3.9-1.5l5.2-4.9c1.1-1 1.7-2.3 1.7-3.7V6.5C42 4 39.8 2 37.2 2zM17 34.5s0 .5-.6.5h-2.7s-.7 0-.7-.8l-.7-12.8s0-.8.7-.8h3.2s.8 0 .8 1v12.9zm16.2-1.9s-.7 2.4-1.6 2.4H22c-.7 0-2.4-.5-2.4-1.7V20.6s4.8-3.5 4.8-8c.1-.2-.2-1.6 1.5-1.6 0 0 4.2.5 1.7 9.6H34s1.6-.1 1.6 1.5c0 0 0 2.4-2.4 10.5z" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
